var StepTwoV1CMSView, SupportCMSModel, SupportHorizontalViewManagerBase, SupportOptimizedContactChannelsModel, SupportV1INTLStepThreeView, SupportV1INTLViewManager, SupportV1StepActionsModel, SupportV1StepOneView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV1INTLStepThreeView = require('../../views/step_three/INTL/v1_view');

SupportV1StepOneView = require('../../views/step_one/v1_view');

SupportV1StepActionsModel = require('../../models/v1_step_action');

SupportCMSModel = require('../../models/CMS');

StepTwoV1CMSView = require('../../views/step_two/CMS/v1_cms_view');

SupportHorizontalViewManagerBase = require('../horizontal_view_manager_base');

SupportOptimizedContactChannelsModel = require('../../models/optimized_contact_channels');

SupportV1INTLViewManager = (function(superClass) {
  extend(SupportV1INTLViewManager, superClass);

  function SupportV1INTLViewManager() {
    SupportHorizontalViewManagerBase.prototype.constructor.apply(this, arguments);
    Groupon.Support.stepActionModel = new SupportV1StepActionsModel;
  }

  SupportV1INTLViewManager.prototype.getStepOneView = function() {
    return new SupportV1StepOneView();
  };

  SupportV1INTLViewManager.prototype.getStepTwoView = function() {
    return Groupon.Support.StepTwoView = new StepTwoV1CMSView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns
    });
  };

  SupportV1INTLViewManager.prototype.getStepThreeView = function() {
    return new SupportV1INTLStepThreeView();
  };

  SupportV1INTLViewManager.prototype.configureContentModel = function() {
    return Groupon.Support.ContentModel = new SupportCMSModel;
  };

  SupportV1INTLViewManager.prototype.configureOptimizedContactChannelsModel = function() {
    return Groupon.Support.OptimizedContactChannelsModel = new SupportOptimizedContactChannelsModel;
  };

  return SupportV1INTLViewManager;

})(SupportHorizontalViewManagerBase);

module.exports = SupportV1INTLViewManager;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld19tYW5hZ2VyL0lOVEwvdjEuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld19tYW5hZ2VyL0lOVEwvdjEuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsZ05BQUE7RUFBQTs7O0FBQUEsMEJBQUEsR0FBNkIsT0FBQSxDQUFRLHFDQUFSOztBQUM3QixvQkFBQSxHQUF1QixPQUFBLENBQVEsOEJBQVI7O0FBQ3ZCLHlCQUFBLEdBQTRCLE9BQUEsQ0FBUSw2QkFBUjs7QUFDNUIsZUFBQSxHQUFrQixPQUFBLENBQVEsa0JBQVI7O0FBQ2xCLGdCQUFBLEdBQW1CLE9BQUEsQ0FBUSxzQ0FBUjs7QUFDbkIsZ0NBQUEsR0FBbUMsT0FBQSxDQUFRLGlDQUFSOztBQUNuQyxvQ0FBQSxHQUF1QyxPQUFBLENBQVEseUNBQVI7O0FBRWpDOzs7RUFDUyxrQ0FBQTtJQUNYLGdDQUFnQyxDQUFBLFNBQUUsQ0FBQSxXQUFXLENBQUMsS0FBOUMsQ0FBb0QsSUFBcEQsRUFBMEQsU0FBMUQ7SUFDQSxPQUFPLENBQUMsT0FBTyxDQUFDLGVBQWhCLEdBQWtDLElBQUk7RUFGM0I7O3FDQUliLGNBQUEsR0FBZ0IsU0FBQTtXQUNkLElBQUksb0JBQUosQ0FBQTtFQURjOztxQ0FHaEIsY0FBQSxHQUFnQixTQUFBO1dBQ2QsT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFoQixHQUE4QixJQUFJLGdCQUFKLENBQXFCO01BQ2hELGFBQUEsRUFBZSxPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxTQURJO0tBQXJCO0VBRGhCOztxQ0FLaEIsZ0JBQUEsR0FBa0IsU0FBQTtXQUNoQixJQUFJLDBCQUFKLENBQUE7RUFEZ0I7O3FDQUdsQixxQkFBQSxHQUF1QixTQUFBO1dBQ3JCLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBaEIsR0FBK0IsSUFBSTtFQURkOztxQ0FHdkIsc0NBQUEsR0FBd0MsU0FBQTtXQUN0QyxPQUFPLENBQUMsT0FBTyxDQUFDLDZCQUFoQixHQUFnRCxJQUFJO0VBRGQ7Ozs7R0FuQkg7O0FBc0J2QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
